import http from './api'

// Fair values of holdings computed from the fund valuation reports (server
// docs/fund-fair-value.md). Read only. The list takes `date` and `view` (ifrs | live), the
// breakdown of one fund `date` and `private_investment_fund`; both take `portfolio`, which
// the shared serializer sends as `portfolio[]` when it is an array.
export const httpGetFairValues = (params) => {
  return http({
    url: `/private_investment_funds/fair_values/`,
    method: 'GET',
    params,
  })
}
